import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IRelationshipsAndGuarantorsState } from '../store/relationshipsAndGuarantors.types'
import { getRelationshipsAndGuarantors } from '../selectors/getRelationshipsAndGuarantors.selector'
import {
  setResponse,
  saveRelationshipsAndGuarantors as setRelationshipsAndGuarantors,
} from '../store/relationshipsAndGuarantors.action'
import { RelationshipsAndGuarantorsConstants } from '../store/relationshipsAndGuarantors.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* saveRelationshipsAndGuarantors() {
  const relationshipsAndGuarantors: IRelationshipsAndGuarantorsState = yield select(getRelationshipsAndGuarantors)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = {
      ...pcrDoc,
      billing: { ...pcrDoc.billing, relationshipsAndGuarantors },
    }
    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setResponse(response))
      yield put(setRelationshipsAndGuarantors())
    } catch (e) {
      yield put(throwPcrException(`saveRelationshipsAndGuarantors() error: ${e}`))
    }
  }
}

export function* saveRelationshipsAndGuarantorsSaga() {
  yield takeLatest(
    [
      RelationshipsAndGuarantorsConstants.SET_RELATIONSHIP,
      RelationshipsAndGuarantorsConstants.SET_NEXT_OF_KIN,
      RelationshipsAndGuarantorsConstants.SET_SAME_RESIDENCE,
      RelationshipsAndGuarantorsConstants.SET_FIRST_NAME,
      RelationshipsAndGuarantorsConstants.SET_MIDDLE_INITIAL,
      RelationshipsAndGuarantorsConstants.SET_LAST_NAME,
      RelationshipsAndGuarantorsConstants.SET_SUFFIX,
      RelationshipsAndGuarantorsConstants.SET_UNKNOWN_NAME,
      RelationshipsAndGuarantorsConstants.SET_DOB,
      RelationshipsAndGuarantorsConstants.SET_AGE,
      RelationshipsAndGuarantorsConstants.SET_AGE_UNIT,
      RelationshipsAndGuarantorsConstants.SET_SSN,
      RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE,
      RelationshipsAndGuarantorsConstants.SET_DRIVERS_LICENSE_STATE,
      RelationshipsAndGuarantorsConstants.SET_RELATIONSHIPS_AND_GUARANTORS_LIST,
    ],
    performWithMutexHOG,
    saveRelationshipsAndGuarantors
  )
}
